import { Injectable } from '@angular/core';
import { DossierDto, DossierSearchResultDto } from '@scip/api';
import { DossierControllerService, ReportControllerService } from '@scip/api';
import { NotificationService } from './notification.service';
import { downloadFile, translationKeys } from '../core';
import { catchError, mapTo, tap, withLatestFrom } from 'rxjs/operators';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
  private _isInDownload = new BehaviorSubject<number[]>([]);

  get isInDownload(): Observable<number[]> {
    return this._isInDownload.asObservable();
  }

  constructor(
    private dossierControllerService: DossierControllerService,
    private notificationService: NotificationService,
    private reportControllerService: ReportControllerService
  ) {}

  downloadDossier(dossierDto: DossierSearchResultDto | DossierDto): Observable<void> {
    this._isInDownload.next([...this._isInDownload.value, dossierDto.dossierId]);
    return this.dossierControllerService.getDossierFilePath(dossierDto.dossierId).pipe(
      withLatestFrom(this.isInDownload),
      tap(([item, idsInDownload]: [Blob, number[]]) => {
        const blob = new Blob([item], { type: 'application/zip' });
        downloadFile(blob, dossierDto.filename);
        this._isInDownload.next(idsInDownload.filter((id) => id !== dossierDto.dossierId));
      }),
      catchError((error) => {
        this._isInDownload.next(this._isInDownload.value.filter((id) => id !== dossierDto.dossierId));
        this.notificationService.showError(translationKeys.downloadService.msg.downloadError);
        return of(null);
      })
    );
  }

  downloadReport(reportId: number, fileName: string): Observable<void> {
    return this.reportControllerService.getReport(reportId).pipe(
      tap((item: Blob) => {
        const blob = new Blob([item], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        downloadFile(blob, fileName);
      }),
      mapTo(null),
      catchError(() => {
        this.notificationService.showError(translationKeys.downloadService.msg.downloadError);
        return of(null);
      })
    );
  }
}
